module.exports = __webpack_public_path__ + "static/media/BISON-BNB-APE.d171a8c9.png";